import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import Loading from '../../components/loading/Loading';

export default function RouteNotAuth(): JSX.Element {
	const { isAuth, authChecked } = useSelector((state: RootState) => state.auth);

	if (!authChecked) {
		return <Loading />;
	}

	return isAuth ? <Navigate to="/" replace /> : <Outlet />;
}
